document.addEventListener('DOMContentLoaded', () => {
  // Immer zuerst entfernen – sauberer Ausgangszustand
  document.body.classList.remove('ks-event-active');

  const bar = document.querySelector('[data-ks-event-bar]');

  // FIX: Nur aktiv wenn data-ks-event-active="true" gesetzt ist
  // Das Snippet setzt dieses Attribut nur wenn ein echter Event läuft
  if (!bar || bar.getAttribute('data-ks-event-active') !== 'true') return;

  document.body.classList.add('ks-event-active');

  const countdownEl  = bar.querySelector('[data-ks-countdown]');
  const countdownWrap = bar.querySelector('.ks-event-bar__countdown-wrap');
  const endTsRaw     = bar.getAttribute('data-end-ts');

  const removeUrgencyClasses = () => {
    bar.classList.remove('is-ending-soon', 'is-ending-today', 'is-ending-final', 'is-expired');
    if (countdownWrap) {
      countdownWrap.classList.remove('is-ending-soon', 'is-ending-today', 'is-ending-final', 'is-expired');
    }
  };

  const applyUrgencyClasses = (diffSeconds) => {
    removeUrgencyClasses();

    if (diffSeconds <= 0) {
      bar.classList.add('is-expired');
      if (countdownWrap) countdownWrap.classList.add('is-expired');
      // Event abgelaufen → Klasse wieder entfernen damit Ankündigungsleiste erscheint
      document.body.classList.remove('ks-event-active');
      return;
    }

    if (diffSeconds <= 3 * 60 * 60) {
      bar.classList.add('is-ending-final');
      if (countdownWrap) countdownWrap.classList.add('is-ending-final');
      return;
    }

    if (diffSeconds <= 12 * 60 * 60) {
      bar.classList.add('is-ending-today');
      if (countdownWrap) countdownWrap.classList.add('is-ending-today');
      return;
    }

    if (diffSeconds <= 24 * 60 * 60) {
      bar.classList.add('is-ending-soon');
      if (countdownWrap) countdownWrap.classList.add('is-ending-soon');
    }
  };

  if (countdownEl && endTsRaw) {
    const endTs = parseInt(endTsRaw, 10);

    if (!Number.isNaN(endTs) && endTs > 0) {
      let intervalId = null;

      const renderCountdown = () => {
        const nowTs = Math.floor(Date.now() / 1000);
        const diff  = endTs - nowTs;

        applyUrgencyClasses(diff);

        if (diff <= 0) {
          countdownEl.textContent = '00:00:00';
          if (intervalId) window.clearInterval(intervalId);
          return;
        }

        const hours   = Math.floor(diff / 3600);
        const minutes = Math.floor((diff % 3600) / 60);
        const seconds = diff % 60;

        countdownEl.textContent = [
          String(hours).padStart(2, '0'),
          String(minutes).padStart(2, '0'),
          String(seconds).padStart(2, '0')
        ].join(':');
      };

      renderCountdown();
      intervalId = window.setInterval(renderCountdown, 1000);
    }
  }

  const copyButton = bar.querySelector('[data-ks-copy-code]');
  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const code = copyButton.getAttribute('data-code');
      if (!code) return;

      const valueNode = copyButton.querySelector('.ks-event-bar__code-value');
      const original  = valueNode ? valueNode.textContent : '';

      try {
        await navigator.clipboard.writeText(code);
        copyButton.classList.add('is-copied');
        if (valueNode) valueNode.textContent = 'Kopiert ✓';

        window.setTimeout(() => {
          copyButton.classList.remove('is-copied');
          if (valueNode) valueNode.textContent = original;
        }, 1600);
      } catch (error) {
        console.error('KS Event Code copy failed:', error);
      }
    });
  }
});
